import axios from "axios"
export function linkScreen(phoneNumber, screenCode, screenName, token) {
    return axios.post(process.env.REACT_APP_API_URL+ '/linkNewScreen', { phoneNumber, screenCode, screenName }, {
        headers: {
            'Authorization': `${token}`
        }});
}